<template>
  <modal
    name="delete-patient-modal"
    :classes="['modal-window']"
    transition="scale"
    :adaptive="true"
    :scrollable="true"
    :width="300"
    height="auto"
    @before-open="beforeOpen"
  >
    <div class="modal-container">
      <div class="modal-window-content">
        <p class="title">{{ $t('dashboard.label.deletePatient') }}</p>
        <div class="buttons-group">
          <a class="cancel-button" @click="cancel">
            {{ $t('dashboard.action.cancel') }}
          </a>
          <button
            class="rounded-button-white"
            :class="{ 'rounded-button-white__alma': isAlmaTerritory }"
            @click="onPatientDelete"
          >
            {{ $t('dashboard.action.yesDelete') }}
          </button>
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
import { mapActions } from 'vuex';
import isAlmaTerritories from '@/modules/dashboard/components/mixins/isAlmaTerritories';

import { types } from '@/modules/dashboard/store/types';

export default {
  name: 'DeletePatientModal',
  mixins: [isAlmaTerritories],
  data() {
    return {
      patientId: null
    };
  },
  methods: {
    ...mapActions({
      deletePatient: types.actions.DELETE_PATIENT
    }),
    beforeOpen({ params: { patientId } }) {
      this.patientId = patientId;
    },
    cancel() {
      this.hideModal();
    },
    async onPatientDelete() {
      if (this.patientId) {
        await this.deletePatient(this.patientId);

        this.$emit('patient-delete');
      }

      this.hideModal();
    },
    hideModal() {
      this.$modal.hide('delete-patient-modal');
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../../../../assets/scss/common/buttons';

.modal-window-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 300px;
  height: 210px;
  box-sizing: border-box;
  padding: 20px;

  background-color: #ffffff;
  font-family: var(--u-font-family-Gilroy);
  border-radius: 8px;
}

.title {
  margin-top: 40px;
  margin-bottom: 40px;

  font-size: 15px;
  line-height: 17px;

  color: #324752;
}

.cancel-button {
  font-size: 15px;
  line-height: 17px;

  text-decoration: none;

  color: #8da4b0;
}

.rounded-button-white {
  font-size: 15px;
  line-height: 17px;
}

.buttons-group {
  width: 100%;
  display: flex;
  justify-content: space-around;
  align-items: center;
}
</style>
